import {actions as A} from '../constants/actions';
import config from '../config/common';

const defaultState = {
    current: config.locale.default,
    translations: null,
    loading: true,
    error: false,
    errorMessage: null
};

export default (state = defaultState, {type, payload}) => {
    switch(type) {
        case A.SET_LOCALE:
            const {current} = payload;

            return {...state, current};

        case A.GET_TRANSLATIONS:
            return {...state, loading: true};

        case A.GET_TRANSLATIONS_SUCCESS:
            const {translations} = payload;
            return {...state, loading: false, translations};

        case A.GET_TRANSLATIONS_FAILURE:
            const {errorMessage} = payload;
            return {...state, loading: false, error: true, errorMessage};

        default:
            return state;
    }
}
